
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function AdoptCTA() {
  return (
    <section className="relative py-16 sm:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e30756b9e96c2403872b67e7d6517e3d.jpg"
          alt="Give a cat a forever home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-accent/90 via-accent/80 to-accent/90"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-white mb-4"
        >
          Ready to Change a Life?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="font-body text-white/90 text-sm sm:text-lg mb-8 max-w-2xl mx-auto"
        >
          Every cat deserves a warm home and a loving family. Start your adoption journey today and give a shelter cat their happily ever after.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-3 sm:gap-5 justify-center"
        >
          <a
            href="#adoptable-cats"
            className="px-8 py-4 bg-white text-accent font-heading font-bold text-base rounded-full hover:scale-105 transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-search-line"></i>
            Browse Adoptable Cats
          </a>
          <Link
            to="/contact"
            className="px-8 py-4 bg-transparent border-2 border-white text-white font-heading font-bold text-base rounded-full hover:bg-white hover:text-accent transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-question-line"></i>
            Learn About the Process
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
